import { useEffect, useState } from "react";

/** Add/remove the cream theme class on the body only while this page is mounted. */
export function useCreamTheme() {
  useEffect(() => {
    document.body.classList.add("articleCream");
    return () => document.body.classList.remove("articleCream");
  }, []);
}

/** Reading progress (0–100) for a scrolling article element. */
export function useReadingProgress(targetRef) {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const el = targetRef.current;
      if (!el) return;
      const top = el.offsetTop;
      const total = el.scrollHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(window.scrollY - top, 0), total);
      setPct(total > 0 ? (scrolled / total) * 100 : 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [targetRef]);

  return pct;
}

function slugify(text = "") {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export function useTOC(targetRef, key) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const el = targetRef.current;
    if (!el) return;

    const hs = Array.from(el.querySelectorAll("h2, h3"));
    const out = hs.map((h) => {
      if (!h.id) h.id = slugify(h.textContent || "");
      return {
        id: h.id,
        text: h.textContent || "",
        level: h.tagName === "H3" ? 3 : 2,
      };
    });
    setItems(out);
  }, [targetRef, key]);

  return items;
}
